export const sidebar = {
  header: {
    menu: "MENU",
  },
  items: {
    home: "Accueil",
    reservations: "Réservations",
    calendar: "Calendrier",
    hourlyCalendar: "À l'heure",
    calls: "Appels",
    aiReception: "Réception IA",
    availabilityRates: "Disponibilité et tarifs",
    checkins: "Check-ins",
    channels: "Canaux de réservation",
    inbox: "Boîte de réception",
    settings: "Paramètres",
    experiences: "Expériences",
    scheduleCall: "Planifier un appel",
    support: "Assistance",
    novedades: "Nouveautés",
    messages: "Messages",
    badgeNew: "Nouveau",
    invoicing: "Facturation",
    customers: "Clients",
    clientsDirectory: "Clients",
    fiscalCustomers: "Clients fiscaux",
    invoices: "Factures",
    housekeeping: "Ménage",
    analytics: "Analytics",
  },
  alt: {
    logo: "Logo",
  },
};
